export default "__VITE_ASSET__B81r579M__"